import { useEffect, useState } from 'react';

import { apiClient } from '@/lib/api-client';

let cachedEnabled: boolean | null = null;
let pending: Promise<boolean> | null = null;

const readFlag = (body: unknown): boolean => {
  if (!body || typeof body !== 'object') return false;
  const root = body as Record<string, unknown>;
  const data =
    root.data && typeof root.data === 'object' ? (root.data as Record<string, unknown>) : root;
  if (typeof data.file_library_enabled === 'boolean') return data.file_library_enabled;
  const features =
    data.features && typeof data.features === 'object'
      ? (data.features as Record<string, unknown>)
      : null;
  return features?.file_library_enabled === true;
};

const fetchFlag = async (): Promise<boolean> => {
  if (cachedEnabled !== null) return cachedEnabled;
  if (!pending) {
    pending = apiClient
      .get('/version')
      .then((res) => readFlag(res.data))
      .catch(() => false)
      .then((enabled) => {
        cachedEnabled = enabled;
        pending = null;
        return enabled;
      });
  }
  return pending;
};

export const useFileLibraryFeatureEnabled = (): boolean => {
  const [enabled, setEnabled] = useState(cachedEnabled === true);

  useEffect(() => {
    let alive = true;
    void fetchFlag().then((value) => {
      if (alive) setEnabled(value);
    });
    return () => {
      alive = false;
    };
  }, []);

  return enabled;
};

export const resetFileLibraryFeatureCacheForTest = (): void => {
  cachedEnabled = null;
  pending = null;
};
